module.exports = __webpack_public_path__ + "img/ifmInsp.c5a20b66.svg";